import uiCore = require("../core/uicore");

export class SaveOrCancelButtonsDirective implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewsaveorcancelbuttons",
        Template: require("./crewsaveorcancelbuttons.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            okbuttontext: "@okbuttontext",
            cancelbuttontext: "@",
            onsave: "&",
            oncancel: "&"
        }
    }

    public onsave: () => void;
    public oncancel: () => void;

    public okbuttontext: string = "OK";
    public cancelbuttontext: string = "Cancel";

    public privateonsave() {
        if (this.onsave) this.onsave();
    }

    public privateoncancel() {
        if (this.oncancel) this.oncancel();

    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewsaveorcancelbuttons.ts